<template>
    <div class="course-box">
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>年度培训计划</el-breadcrumb-item>
        </el-breadcrumb>

        <my-table height="80%" :columns="customColumns" :tableData="tableData" :loading="isLoading">
            <el-table-column prop="userSex" label="操作">
                <template slot-scope="scope">
                    <div class="d-flex fz14 col-29f cs-pit">
                        <div class="operate" @click="handleAction(scope.row)">
                            <span v-buttonAuth="'system:annualPlanDept:detailList'">详情</span>
                        </div>
                    </div>
                </template>
            </el-table-column>
        </my-table>
        <!-- <div class="main-pagination">
        <Pagination :child-msg="pageInfo" @callFather="callFather"></Pagination>
      </div> -->
    </div>
</template>

<script>
import MyTable from '@/components/myTable.vue';
import Pagination from '@/components/Pagination'
import api from '../../api/onlineTraining/annualPlan';
import { fileDownload } from "../../utils/util";
export default {
    components: {
        MyTable,
        Pagination,
    },
    data () {
        return {

            customColumns: [
                { label: '部门名称', prop: 'deptName' }
            ],
            isLoading: false,
            tableData: [],
            pageInfo: { currentPage: 1, pageSize: 10, total: 0 }, //  分页参数

        }
    },
    created () {
        this.getData();
    },
    methods: {
        handleAction(item){
            this.$router.push({
                path: '/onlineTraining/annualPlan',
                query: {
                    deptId: item.deptId
                }
            })
        },
        //  改变分页及大小
        callFather (data) {
            this.pageInfo.currentPage = data.currentPage;
            this.pageInfo.pageSize = data.pageSize;
            this.getData();
        },
        //  获取数据
        async getData () {
            const params = {
                pageNum: this.pageInfo.currentPage,
                pageSize: this.pageInfo.pageSize
            };
            const res = await api.deptList();
            this.tableData = res.data;
            // this.pageInfo.total = res.data.total;
        },
    }
}
</script>

<style lang="scss" scoped>
.course-box {
    height: 100%;

    .user-search {
        margin-top: 20px;
    }

    .operate {
        margin-left: 10px;

        &:first-child {
            margin-left: 0;
        }
    }

    .view-list {
        width: 70%;
        margin: 0 auto;
        font-size: 16px;

        .view-item {
            display: flex;
            align-items: flex-start;
            padding: 5px 0;

            .view-label {
                width: 100px;
                text-align: right;
            }
        }
    }
}
</style>
<style lang="scss">
.el-loading-mask {
    z-index: 5000 !important;
}
</style>


// WEBPACK FOOTER //
// src/views/onlineTraining/annualPlanDept.vue